import { customBaseQuery } from '@/lib/baseQuery';
import { ApiResponse } from '@/shared/types';
import { createApi } from '@reduxjs/toolkit/query/react';

export const taxApi = createApi({
  reducerPath: 'taxApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getAllTaxDiagnosticList: builder.query<
      ApiResponse<any>,
      {
        page: number;
        limit?: number;
      }
    >({
      query: ({ page, limit = 20 }) => {
        return {
          url: `tax/diagnostic`,
          method: 'GET',
          params: {
            page: page,
            limit,
          },
        };
      },
    }),
    createTaxDiagnostic: builder.mutation<
      ApiResponse<any>,
      {
        clientDetail: { email: string; firstName: string; lastName: string };
        answers: any;
      }
    >({
      query: ({ clientDetail, answers }) => ({
        url: 'tax/diagnostic',
        method: 'POST',
        body: {
          email: clientDetail.email,
          firstName: clientDetail.firstName,
          lastName: clientDetail.lastName,
          formSlug: 'au_tax_assessment',
          formVersion: 1,
          answers,
        },
      }),
    }),
  }),
});

export const {
  useCreateTaxDiagnosticMutation,
  useGetAllTaxDiagnosticListQuery,
} = taxApi;
